import { render, staticRenderFns } from "./ModalAcceptCookies.vue?vue&type=template&id=76fa902c&scoped=true"
import script from "./ModalAcceptCookies.vue?vue&type=script&lang=js"
export * from "./ModalAcceptCookies.vue?vue&type=script&lang=js"
import style0 from "./ModalAcceptCookies.vue?vue&type=style&index=0&id=76fa902c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fa902c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76fa902c')) {
      api.createRecord('76fa902c', component.options)
    } else {
      api.reload('76fa902c', component.options)
    }
    module.hot.accept("./ModalAcceptCookies.vue?vue&type=template&id=76fa902c&scoped=true", function () {
      api.rerender('76fa902c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ModalAcceptCookies.vue"
export default component.exports